export const routeTitles = {
  DASHBOARD: 'Dashboard',
  DASHBOARD_RECEIVABLES: 'Receivable Dashboard',
  DASHBOARD_COLLECTIONS: 'Collection Dashboard',
  DASHBOARD_PROJECTIONS: 'Projection Dashboard',
  CUSTOMER_DIRECTORY: 'Customer Directory',
  STATEMENTS: 'Customer Statements',
  INDIVIDUAL: 'Individual Statements',
  BULK: 'Bulk Statements',
  JOURNALS: 'Journals',
  REPORTS: 'Reports',
  GLCONFIG: 'GL configuration',
  ACCOUNT_TYPE_DEFINITION: 'Account Type Definition',
  SEGMENT_DEFINITION: 'Segment Definition',
  ACCOUNT_NUMBER: 'Account Number',
  GL_TEMPLATE: 'GL Template',
  SETTINGS: 'Settings',
  PRIVACYPOLICY: 'Privacy Policy',
  HELPCENTER: 'Help Center',
  GL_CONFIG_SCREEN: 'GL Configuration Screen',
  GL_EXCEPTION_SCREEN: 'GL Exception Screen',
  TRUST_GL_EXCEPTION_SCREEN: 'Trust GL Exception Screen',
  TRUST_GL_CONFIG_SCREEN: 'Trust GL Configuration Screen',
  TRUST: 'Trust',
};

export const routes = {
  LOGIN: '/',
  DASHBOARD: '/dashboard',
  DASHBOARD_RECEIVABLES: '/dashboard-receivables',
  DASHBOARD_COLLECTIONS: '/dashboard-collections',
  DASHBOARD_PROJECTIONS: '/dashboard-projections',
  CUSTOMER_DIRECTORY: '/customerDirectory',
  STATEMENTS: '/statements',
  INDIVIDUAL: '/individual',
  BULK: '/bulk',
  JOURNALS: '/journals',
  REPORTS: '/reports',
  GLCONFIG: '/glconfig',
  GL_CONFIG_SCREEN: '/glconfigscreen',
  GL_EXCEPTION_SCREEN: '/glexceptionscreen',
  TRUST_GL_EXCEPTION_SCREEN: '/trustGlexceptionscreen',
  TRUST_GL_CONFIG_SCREEN: '/trustglconfigscreen',
  ACCOUNT_TYPE_DEFINITION: '/accountTypeDefinition',
  SEGMENT_DEFINITION: '/segmentDefinition',
  ACCOUNT_NUMBER: '/accountNumber',
  GL_TEMPLATE: '/glTemplate',
  SETTINGS: '/settings',
  PRIVACYPOLICY: '/privacypolicy',
  HELPCENTER: '/helpcenter',
  TRUST: '/trust',
  TRUST_ACCOUNTS: '/trustAccounts',
  TRUST_DEFAULTS: '/trustDefaults',
  TRUST_CLOSED: '/trustClosed',
  TRUST_EQUITY: '/trustEquityOnCancelled',
  TRUST_ITEMS_REPORT: '/trustItemsReport',
  TRUST_MONTHLY_REPORT: '/trustMonthlyReport',
  TRUST_DETAILED_REPORT: '/trustDetailedReport',
};
